import React, { useEffect, useState } from 'react'
import CopyIcon from '@material-ui/icons/FileCopy'
import { IconButton } from '@material-ui/core'

import LargeToolTip from '../../../account/components/LargeToolTip'

const noop = () => {}

const ClipboardButton = props => {
  const {
    value,
    onCopy = noop,
    title = 'Copy',
    copiedTitle = 'Copied!',
    style = {},
    className = '',
  } = props
  const [copied, setCopied] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let timer = null
    if (copied) {
      timer = setTimeout(() => {
        setCopied(false)
      }, 3000)
    }
    return (() => {
      if (timer) {
        clearTimeout(timer)
      }
    })
  }, [copied])

  return (
    <LargeToolTip title={copied ? copiedTitle : title}>
      <IconButton
        style={style}
        className={className}
        onClick={() => {
          navigator.clipboard.writeText(value).then(() => {
              navigator.clipboard.writeText(value).then(() => {
                onCopy()
                setCopied(true)
                setError(null)
              })
            }, (err) => {
              console.error('Clipboard write error:', err)
              setError(err)
            })
        }}
      >
        <CopyIcon />
      </IconButton>
    </LargeToolTip>
  ) 
}

export default ClipboardButton
